import script from "./AnnotationSetListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotationSetListItem.vue?vue&type=script&setup=true&lang=js"

import "./AnnotationSetListItem.vue?vue&type=style&index=0&id=2e9172d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9172d4"]])

export default __exports__